import { ethers } from 'ethers';
import { initWalletConnect } from '../wallet';
import { connectWallet, verifySignature } from '../api/wallets';
import { useQueryClient } from '@tanstack/react-query';

export const useWalletConnect = () => {
  const queryClient = useQueryClient();

  const handleWalletConnect = async () => {
    console.log('Connecting to Wallet...');

    const provider = await initWalletConnect();
    const ethersProvider = new ethers.BrowserProvider(provider);
    const signer = await ethersProvider.getSigner();
    const address = await signer.getAddress();

    console.log('Connected address:', address);

    try {
      // 1. Fetch nonce from backend
      const nonce = await connectWallet(address);

      // 2. Sign nonce
      const signature = await signer.signMessage(`Sign to verify: ${nonce}`);

      // 3. Send signature to backend
      await verifySignature(address, signature);

      await queryClient.invalidateQueries({ queryKey: ['user'] });
    } catch (error) {
      //@ts-expect-error Type 'Error' includes message.
      alert(`Error: ${error.message}`);
    }
  };

  return { handleWalletConnect };
};
